import clsx from 'clsx';
import React from 'react';

import IconFacebook from '@components/Images/Rebranding/IconFacebook';
import IconInstagram from '@components/Images/Rebranding/IconInstagram';
import IconLinkedIn from '@components/Images/Rebranding/IconLinkedIn';
import IconX from '@components/Images/Rebranding/IconX';
import { encodeEntity } from '@utils/formatting';

import styles from './styles.module.scss';

type theme = 'default' | 'blackBoxStyle';

function SocialLink({
  href,
  icon,
  isBlackBoxStyle,
}: {
  href: string;
  icon?: React.ReactNode;
  isBlackBoxStyle;
}) {
  return (
    <div className={clsx({ [styles.borderLinkWrapper]: isBlackBoxStyle })}>
      <a
        className={clsx(styles.socialLink, { [styles.blackBoxStyle]: isBlackBoxStyle })}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {icon}
      </a>
    </div>
  );
}

export default function SocialLinks({
  instagram,
  linkedIn,
  twitter,
  facebook,
  theme = 'default',
}: {
  instagram?: string | null;
  linkedIn?: string | null;
  twitter?: string | null;
  facebook?: string | null;
  theme?: theme;
}) {
  const renderSocialLinks = instagram || linkedIn || twitter || facebook;
  const isBlackBoxStyle = theme === 'blackBoxStyle';

  return (
    <>
      {renderSocialLinks && (
        <div
          className={clsx(styles.socialLinksContainer, {
            [styles.blackBoxStyle]: isBlackBoxStyle,
          })}
        >
          {twitter && (
            <SocialLink
              href={`https://twitter.com/${encodeEntity(twitter)}`}
              isBlackBoxStyle
              icon={
                <IconX
                  className={clsx({
                    'h-[22px] w-[22px]': isBlackBoxStyle,
                    'h-[30px] w-[30px]': !isBlackBoxStyle,
                  })}
                />
              }
            />
          )}
          {linkedIn && (
            <SocialLink
              // reinstate "/" back into linked in handle because it might look something like company/handle and don't want to encode the "/"
              href={`https://linkedin.com/${encodeEntity(linkedIn).replace('%2F', '/')}`}
              isBlackBoxStyle
              icon={
                <IconLinkedIn
                  className={clsx({
                    'h-[22px] w-[22px]': isBlackBoxStyle,
                    'h-[30px] w-[30px]': !isBlackBoxStyle,
                  })}
                />
              }
            />
          )}
          {instagram && (
            <SocialLink
              href={`https://instagram.com/${encodeEntity(instagram)}`}
              isBlackBoxStyle
              icon={
                <IconInstagram
                  className={clsx({
                    'h-[22px] w-[22px]': isBlackBoxStyle,
                    'h-[30px] w-[30px]': !isBlackBoxStyle,
                  })}
                />
              }
            />
          )}
          {facebook && (
            <SocialLink
              href={`https://facebook.com/${encodeEntity(facebook)}`}
              isBlackBoxStyle
              icon={
                <IconFacebook
                  className={clsx({
                    'h-[22px] w-[22px]': isBlackBoxStyle,
                    'h-[30px] w-[30px]': !isBlackBoxStyle,
                  })}
                />
              }
            />
          )}
        </div>
      )}
    </>
  );
}
